// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2ZP2P","name":"ConsentHeader_name__10NgI","birthday":"ConsentHeader_birthday__1HZZS","skeleton":"ConsentHeader_skeleton__3K8oH"};